"use client";

import { useEffect } from "react";

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (
      typeof window === "undefined" ||
      !("serviceWorker" in navigator) ||
      (window.location.protocol !== "https:" &&
        window.location.hostname !== "localhost")
    ) {
      return;
    }

    const register = async () => {
      try {
        // Desregistrar service workers antigos primeiro
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
        }

        // Registrar novo service worker
        const registration = await navigator.serviceWorker.register("/sw.js", {
          scope: "/",
          updateViaCache: "none",
        });

        console.info("Service Worker registrado com sucesso");

        // Verificar atualizações a cada 60 segundos
        const updateInterval = setInterval(() => {
          registration.update().catch((error) => {
            console.warn("Erro ao verificar atualizações:", error);
          });
        }, 60000);

        // Limpar cache antigo ao carregar
        if ("caches" in window) {
          const currentVersion = "v1.3";
          caches.keys().then((names) => {
            names.forEach((name) => {
              if (!name.includes(currentVersion)) {
                caches.delete(name);
              }
            });
          });
        }

        // Limpar intervalo ao desmontar
        return () => clearInterval(updateInterval);
      } catch (error) {
        // Ignorar erros em desenvolvimento ou quando SW não está disponível
        if (process.env.NODE_ENV === "development") {
          console.warn(
            "Service Worker não registrado em desenvolvimento:",
            error
          );
        } else {
          console.error("Falha ao registrar o Service Worker:", error);
        }
      }
    };

    register();
  }, []);

  return null;
}
